const conversionCities = [
  {
    pref: 43,
    name: "熊本市中央区",
    slug: "kumamotoshichuoku",
    districtSlug: "chuoku",
  },
  {
    pref: 43,
    name: "熊本市西区",
    slug: "kumamotoshinishiku",
    districtSlug: "nishiku",
  },
  {
    pref: 43,
    name: "熊本市南区",
    slug: "kumamotoshiminamiku",
    districtSlug: "minamiku",
  },
  {
    pref: 43,
    name: "熊本市東区",
    slug: "kumamotoshihigashiku",
    districtSlug: "higashiku",
  },
  {
    pref: 40,
    name: "福岡市博多区",
    slug: "fukuokashihakataku",
    districtSlug: "hakataku",
  },
  {
    pref: 33,
    name: "岡山市北区",
    slug: "okayamashikitaku",
    districtSlug: "kitaku",
  },
];
export const conversionCityMap = {};
for (const city of conversionCities) {
  conversionCityMap[city.name] = city;
}

const conversionRegExMap = {
  kumamotoshi: /^熊本県(熊本市.*?区)/,
  okayamashi: /^岡山県(岡山市.*?区)/,
  fukuokashi: /^福岡県(福岡市.*?区)/,
};

export const convertAsset = asset => {
  const conversionRegEx = conversionRegExMap[asset.city];
  if (conversionRegEx) {
    const match = asset.address.match(conversionRegEx);
    if (match) {
      const cityName = match[1];
      const city = conversionCityMap[cityName];
      asset.city = city.slug;
    }
  }
};



// WEBPACK FOOTER //
// ./lib/masterData/cityConversion.js